import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchNcfzLogin, fetchNcfzLogout } from "@features/auth/api/loginApi";
import { setCookie } from "@core/utils/cookieUtil";

export const useFetchNcfzLogin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ secondaryId, secondaryPassword }: { secondaryId: string; secondaryPassword: string }) => fetchNcfzLogin({ secondaryId, secondaryPassword }),
    onSuccess: async (data) => {
      // 쿠키에 ncfz로 로그인헸었다는 값 저장
      setCookie({ key: "isPlayncLogin", value: "false", path: "/" });

      // login-info 재호출
      await queryClient.invalidateQueries({ queryKey: ["loginInfo"] });
    },
  });
};

export const useFetchNcfzLogout = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: fetchNcfzLogout,
    onSuccess: async (data) => {
      // login-info 재호출
      await queryClient.invalidateQueries({ queryKey: ["loginInfo"] });
    },
  });
};
